"use client";

import { useSelector } from "react-redux";

export function useSafeSelector(selector, fallback = {}) {
  try {
    const result = useSelector(selector);

    // Prevent undefined during hydration or slice not ready
    return result ?? fallback;
  } catch (e) {
    console.error("SafeSelector prevented crash:", e);
    return fallback;
  }
}
